import "../../pages/new/new.scss"
import { getAllTerms } from '../../services/termService';
import { getBatches } from '../../services/studentService';
import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../api/axios';
export const AddAnnouncement = () => {
    const navigate = useNavigate();
    const { announcementId } = useParams();
   const [terms, setTerms] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState(null);
    const [batches, setBatches] = useState([]);
    const [degrees, setDegrees] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [errors, setErrors] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const [announcement, setAnnouncement] = useState({
        termId: '',
        batch: '',
        degreeId: '',
        programId: '',
        title: '',
        description: '',
        date: '',
        announcementType: 'SubmissionDeadline',
        submissionType: null,
        termType:null,
        submissionMonth:null,
        submissionDeadline:null,
        submissionDeadlinePptvideo:null
    });
    const fetchTerms = async () => {
        try {
            const data = await getAllTerms();
          //  console.log(data);
            setTerms(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchBatches = async () => {
        try {
            const batchdata = await getBatches();
            setBatches(batchdata.data);
        } catch (err) {
            setError(err);
        }
    };
    const fetchDegreesAndPrograms = async () => {
        try {
            const [degreesRes, programsRes] = await Promise.all([
                axiosInstance.get('/getAllDegrees'),
                axiosInstance.get('/getAllPrograms'),
            ]);
            setDegrees(degreesRes.data?.data || []);
            setPrograms(programsRes.data?.data || []);
        } catch (err) {
            console.error('Error fetching degrees/programs:', err);
        }
    };
    const fetchAnnouncement = async (id) => {
        try {
            const response = await axiosInstance.get(`/getAnnouncementById?id=${id}`);
           // console.log(response.data.data)
            setAnnouncement(response.data.data);
            setSelectedTerm(response.data.data.termId);
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };
    useEffect(() => {
        //fetchThesis();
        fetchTerms();
        fetchBatches();
        fetchDegreesAndPrograms();
    }, []);
    useEffect(() => {        
        if (announcementId) {
            const path = window.location.pathname;
            if(path.includes('edit-announcement')){
                setEditMode(true);
            }
            else if(path.includes('view-announcement')){
                setViewMode(true);
            }
            fetchAnnouncement(announcementId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false); // Set mode to add if no courseId is present
            setViewMode(false);            
        }
    }, [announcementId]);
   
    const handleTermChange = (event) => {
       
        setSelectedTerm(event.target.value);
        setAnnouncement(announcement => ({
            ...announcement,
            termId: event.target.value,
            date: new Date()
        }));
       
    };
    const handleDegreeChange = (event) => {
        const degreeId = event.target.value;
        setAnnouncement(announcement => ({
            ...announcement,
            degreeId,
            programId: ''
        }));
    };
    const filteredPrograms = programs.filter(
        p => !announcement.degreeId || String(p.degreeId) === String(announcement.degreeId)
    );
    const validateForm = () => {
        const errors = {};
       // console.log(announcement);
        if (!selectedTerm) {
            errors.term = 'Term is required';
        }
        if (!announcement.announcementType || !announcement.announcementType.trim()) {
            errors.announcementType = 'announcementType is required';
        }

        if (announcement.announcementType ==='SubmissionDeadline' && (!announcement.submissionType || !announcement.submissionType.trim())) {
            errors.submissionType = 'submissionType is required';
        }

        if (announcement.announcementType ==='SubmissionDeadline' && (!announcement.termType || !announcement.termType.trim())) {
            errors.termType = 'termType is required';
        }

        if (announcement.submissionType ==='Monthly' && (!announcement.submissionMonth || !announcement.submissionMonth.trim())) {
            errors.submissionMonth = 'submissionMonth is required';
        }

        if (announcement.announcementType ==='SubmissionDeadline' && (!announcement.submissionDeadline || !announcement.submissionDeadline.trim())) {
            errors.submissionDeadline = 'submissionDeadline is required';
        }

        if (announcement.announcementType ==='SubmissionDeadline' && (!announcement.submissionDeadlinePptvideo || !announcement.submissionDeadlinePptvideo.trim())) {
            errors.submissionDeadlinePptvideo = 'submissionDeadline is required';
        }
        
        
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        var response='';
       // console.log(announcement);
        try {
            if(viewMode){
                navigate('/announcements');
            }
            else if (editMode) {
                
                // Update course if in edit mode
                response = await axiosInstance.put('/announcements', announcement,{showToastOnResponse: true});
            }
            else{
                
                response = await axiosInstance.post('/announcements', announcement,{showToastOnResponse: true});
            
            }
            navigate('/announcements');
        } catch (error) {
            console.log('Error saving termcourse. Please try again later.');
            console.log(error);
        }
    };
    const goBack = (e) => {
        navigate('/announcements');
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAnnouncement({ ...announcement, [name]: value || ''});
        setErrors({ ...errors, [name]: '' });
    };
    return (
        <div>
            <div className="top">
            <h1>{editMode ? 'Edit Announcement' : viewMode ? 'View Announcement' : 'Add Announcement'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>                       
                        <div className="formInput">
                            <label>Select Term </label>
                            <select id="styled-dropdown"
                                name="term"
                                disabled={viewMode || editMode}
                                value={selectedTerm}
                                onChange={handleTermChange}
                            >
                                <option value="">All Terms</option>
                                {terms && terms.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                            {errors.term && <div className="error-text">{errors.term}</div>}
                        </div>
                        <div className="formInput">
                            <label>Batch </label>
                            <select id="styled-dropdown"
                                name="batch"
                                disabled={viewMode || editMode}
                                value={announcement.batch || ''}
                                onChange={handleChange}
                            >
                                <option value="">All Batches</option>
                                {batches && batches.map(option => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="formInput">
                            <label>Degree </label>
                            <select id="styled-dropdown"
                                name="degreeId"
                                disabled={viewMode || editMode}
                                value={announcement.degreeId || ''}
                                onChange={handleDegreeChange}
                            >
                                <option value="">All Degrees</option>
                                {degrees && degrees.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.degreeName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="formInput">
                            <label>Program </label>
                            <select id="styled-dropdown"
                                name="programId"
                                disabled={viewMode || editMode}
                                value={announcement.programId || ''}
                                onChange={handleChange}
                            >
                                <option value="">All Programs</option>
                                {filteredPrograms.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.programName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="formInput">
            <label>Announcement type</label>
            <select id="styled-dropdown"  
            name="announcementType"
            value={announcement.announcementType}
            onChange={handleChange}
            disabled={viewMode || editMode}
            className={errors.type ? 'error' : ''}>
                <option value="SubmissionDeadline">Submission Deadline</option>
                <option value="Other">Other</option>
            </select>
            {errors.announcementType && <div className="error-text">{errors.announcementType}</div>}
        </div>


        <div className="formInput">
              <label>Announcement Title</label>
              <input type="text" 
              name="title"
              value={announcement.title}
              onChange={handleChange}
              readOnly={viewMode}
              className={errors.title ? 'error' : ''}/>
              {errors.title && <div className="error-text">{errors.title}</div>}
            </div>    

            <div className="formInput">
              <label>Announcement Description</label>
              <input type="text" 
              name="description"
              value={announcement.description}
              onChange={handleChange}
              readOnly={viewMode}
              className={errors.description ? 'error' : ''}/>
              {errors.description && <div className="error-text">{errors.description}</div>}
            </div>  
            {announcement.announcementType ==='SubmissionDeadline' && <div className="formInput">
            <label>Report type</label>
            <select id="styled-dropdown"  
            name="submissionType"
            value={announcement.submissionType}
            onChange={handleChange}
            disabled={viewMode || editMode}
            className={errors.submissionType ? 'error' : ''}>
                <option value="">Select Report Type</option>
                <option value="ProjectParticular">Project Particular</option>
                <option value="ProjectProposal">Project Proposal</option>
                <option value="Phase1">Phase1</option>
                <option value="Phase2">Phase2</option>
                <option value="Phase3">Phase3</option>
                <option value="Monthly">Monthly</option>
            </select>
            {errors.submissionType && <div className="error-text">{errors.submissionType}</div>}
        </div>}
          
          {announcement.announcementType ==='SubmissionDeadline' && <div className="formInput">
            <label>Term type</label>
            <select id="styled-dropdown"  
            name="termType"
            value={announcement.termType}
            onChange={handleChange}
            disabled={viewMode || editMode}
            className={errors.termType ? 'error' : ''}>
                <option value="">Select Submission Type</option>
                <option value="RevisedReport">RevisedReport</option>
                <option value="EndTerm">EndTerm</option>
                {/*<option value="EndTerm_Resubmission">EndTerm Resubmission</option>*/}
                <option value="MidTerm">MidTerm</option>
            </select>
            {errors.termType && <div className="error-text">{errors.termType}</div>}
        </div>}

        {announcement.submissionType ==='Monthly' && <div className="formInput">
            <label>Evaluation Type</label>
            <select id="styled-dropdown"  
            name="submissionMonth"
            value={announcement.submissionMonth}
            onChange={handleChange}
            disabled={viewMode || editMode}
            className={errors.type ? 'error' : ''}>
                <option value="">Select Evaluation Type</option>
                <option value="termiv">Term IV self-evaluation</option>
                <option value="termv_1">Term V self-evaluation 1</option>
                <option value="termv_2">Term V self-evaluation 2</option>
                <option value="termvi_1">Term VI self-evaluation 1</option>
                <option value="termvi_2">Term VI self-evaluation 2</option>
            </select>
            {errors.submissionMonth && <div className="error-text">{errors.submissionMonth}</div>}
        </div>}

        {announcement.announcementType ==='SubmissionDeadline' && <div className="formInput">
            <label>Submission Deadline</label>
            <input
                type="date"
                id="submissionDeadline"
                name="submissionDeadline"
                readOnly={viewMode}
                value={announcement.submissionDeadline}
                onChange={handleChange}
            />
            {errors.submissionDeadline && <div className="error-text">{errors.submissionDeadline}</div>}
        </div>}

        {announcement.announcementType ==='SubmissionDeadline' && <div className="formInput">
            <label>Submission Deadline for Presentation Video</label>
            <input
                type="date"
                id="submissionDeadlinePptvideo"
                name="submissionDeadlinePptvideo"
                readOnly={viewMode}
                value={announcement.submissionDeadlinePptvideo}
                onChange={handleChange}
            />
            {errors.submissionDeadlinePptvideo && <div className="error-text">{errors.submissionDeadlinePptvideo}</div>}
        </div>}

        <div className="buttons">
           {!viewMode && <button type="submit">{editMode ? 'Update' : 'Save'}</button>}
           <button onClick={goBack}>Back</button>
           </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


